import { useState } from "react";
import CompanyOfficialSelection from "./CompanyOfficialSelection";

const IncorporationSubRowAsync = (props) => {
  const {
    visibleColumns,
    row,
    handleBackBtn,
    syncChangesToBOTab,
    currentTab = null,
    isEditMode = false,
  } = props;
  const [mode, setMode] = useState({
    editing: isEditMode,
    id: row.original._id,
    viewing: !isEditMode,
  });
  const [isViewOnly, setIsViewOnly] = useState(false);

  const toggleShowOfficialsForm = (show) => {
    if (show) {
      setMode({ editing: false, id: "", designation: null, viewing: false });
      row?.toggleRowExpanded(false);
      row?.toggleAllRowsExpanded(false);
    }
  };

  return (
    <tr className="bg-[#EDF0F5]">
      <td colSpan={visibleColumns.length} className="px-9">
        <CompanyOfficialSelection
          currentOfficial={row.original}
          toggleShowOfficialsForm={toggleShowOfficialsForm}
          mode={mode}
          component={CompanyOfficialSelection}
          isViewOnly={isViewOnly}
          setIsViewOnly={setIsViewOnly}
          row={row}
        />
      </td>
    </tr>
  );
};

export default IncorporationSubRowAsync;
